namespace Areas.Deputy {
    "use strict";

  
    
    export function save() {

        var iCommentsEditor: any = $('#CommentsEditor').dxHtmlEditor('instance');
        var iComment = iCommentsEditor.option("value");

        var dataGrid = $('#DeputyGrid').dxDataGrid('instance');
        var dataIds = dataGrid.getSelectedRowKeys();
        if (dataIds.length === 0) {
            DevExpress.ui.notify("You need to select a row first!", "warning", 2000);
        }
        else {
            var newData = {
                inspectionIds: dataIds,
                inspectorComment: iComment
            };

            const data = JSON.stringify(newData);
            const url = `/Inspectors/Deputy/WriteUp`;

            sendRequest(url, data, "PUT", () => {
                clearComment();
            });

 
        }

        
    }

    function clearComment() {
        var iCommentsEditor: any = $('#CommentsEditor').dxHtmlEditor('instance');
        iCommentsEditor.option("value", null);
    }
    
}
